<template>
	<div class="index">
		<div class="content">
			<router-view />
		</div>
		<Overlay :show="loadingShow" />
		<div class="loading" v-if="loadingShow">
			<Loading type="spinner" color="#1989fa" />
		</div>
		<div class="orientation-tips" v-show="showOrientation">
			<img src="/img/icon_fanzhuan.png" alt="">
		</div>
		<PopupVue
			class="login-popup"
			:popupConfig="popupConfig"
		/>
		<PopupVue
			class="toast-popup"
			:popupConfig="toastPopupConfig"
		/>
	</div>
</template>

<script>
import { Loading, Overlay } from 'vant';
import {
	getHardWare,
	getUrlKey,
} from '@/lib/util';
import Logs from '@/lib/logs';

import PopupVue from './components/Popup.vue';

import {
	login,
} from './api/common';

export default {
	components: {
		Loading,
		Overlay,
		PopupVue,
	},
	data() {
		return {
			deviceStrict: false,
			showOrientation: false,
			popupConfig: {
				showPopup: false,
				popupContent: `
					<iframe id="login-frame"
						src="${`https://login.sdo.com/sdo/Login/LoginFrameFC.php?pm=2&appId=6666&areaId=-1&thirdParty=wegame&returnURL=${encodeURIComponent(window.location.href)}`}"
						frameborder="0"
						style="margin: 0 auto;display: block;"
					>
					</iframe>
				`,
			},
			toastPopupConfig: {
				showPopup: false,
			},
		};
	},
	methods: {
		webModeFunc() {
			const hardware = getHardWare();
			let webMode = 1;
			const { clientWidth } = document.body;
			let clientModeClass = '';

			if (this.deviceStrict) {
				webMode = hardware === 3 ? 1 : 2;

				if (hardware !== 3) {
					this.orientationFunction();
				}
			} else if (window.matchMedia('(min-width: 500px)').matches) {
				webMode = 1; // PC端样式展示
			} else {
				webMode = 2; // 移动端样式展示
			}

			if (webMode === 1) {
				if (clientWidth <= 836) {
					clientModeClass = 'app-pc-client-1';
				} else if (clientWidth > 836 && clientWidth <= 1260) {
					clientModeClass = 'app-pc-client-2';
				} else {
					clientModeClass = 'app-pc-client-3';
				}
			} else if (webMode === 2) {
				if (clientWidth <= 600) {
					clientModeClass = 'app-mobile-client-1';
				} else if (clientWidth > 600 && clientWidth <= 768) {
					clientModeClass = 'app-mobile-client-2';
				} else {
					clientModeClass = 'app-mobile-client-3';
				}
			}

			document.querySelector('html').className = `app-${webMode === 1 ? 'pc' : 'mobile'}`;
			document.querySelector('html').className += ` ${clientModeClass}`;
		},
		orientationFunction() {
			const ua = navigator.userAgent;
			const isAndroid = /(?:Android)/.test(ua);
			const isFireFox = /(?:Firefox)/.test(ua);
			const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));

			if (window.matchMedia('(orientation: landscape)')?.matches === true) {
				this.showOrientation = true;
			} else if (window.matchMedia('(orientation: portrait)')?.matches === true) {
				this.showOrientation = false;
			} else if (!isTablet) {
				if (window.orientation === 180 || window.orientation === 0) {
					this.showOrientation = false;
				}
				if (window.orientation === 90 || window.orientation === -90) {
					this.showOrientation = true;
				}
			} else {
				if (window.orientation === 180 || window.orientation === 0) {
					this.showOrientation = true;
				}
				if (window.orientation === 90 || window.orientation === -90) {
					this.showOrientation = false;
				}
			}
		},
		getPortrait() {
			let isPortrait = true;

			if (window.matchMedia('(orientation: portrait)')?.matches === true) {
				isPortrait = true;
			} else if (window.matchMedia('(orientation: portrait)')?.matches === false) {
				isPortrait = false;
			} else if (window.orientation === 180 || window.orientation === 0) {
				isPortrait = true;
			} else if (window.orientation === 90 || window.orientation === -90) {
				isPortrait = false;
			} else if (getHardWare() === 3) {
				isPortrait = false;
			}

			return isPortrait;
		},
		loginFunc() {
			const ticket = getUrlKey('ticket');
			const params = {
				ticket,
			};

			login(params).then(res => {
				localStorage.setItem('Authorization', res?.token);
				localStorage.setItem('displayAccount', res?.displayAccount);
				localStorage.setItem('qualification', res?.qualification);

				window.location.href = '/activity';
			}).catch(() => {
				localStorage.clear();
				window.location.href = '/activity';
			});
		},
	},
	created() {
		window.onerror = (message, source, lineno, colno, error) => {
			/* web日志打点 */
			const logs = {
				web_pageid: window.location.pathname,
				web_page_name: window.location.pathname,
				web_buttonid: 'catchError',
				web_ext_json: JSON.stringify({
					catchInfo: {
						message, source, lineno, colno, error,
					},
				}),
			};
			Logs.imgLog_Button(logs);
		};
		window.onlanguagechange = () => {
			window.location.reload();
		};

		window.addEventListener('setItem', e => {
			if (e.key === 'user-login') {
				this.popupConfig = { ...this.popupConfig, showPopup: true };
			}
			if (e.key === 'show-toast') {
				this.toastPopupConfig = {
					showPopup: true,
					popupTitle: '提示',
					popupContent: e.newValue,
					width: '438px',
				};
			}
		});

		window.onload = () => {
			document.addEventListener('touchstart', (event) => {
				if (event.touches.length > 1) {
					event.preventDefault();
				}
			});
			let lastTouchEnd = 0;
			document.addEventListener('touchend', (event) => {
				const now = (new Date()).getTime();
				if (now - lastTouchEnd <= 300) {
					event.preventDefault();
				}
				lastTouchEnd = now;
			}, false);
		};

		const ticket = getUrlKey('ticket');
		if (ticket) {
			this.loginFunc();
		}
	},
	updated() {
		const { deviceStrict } = this.$route.meta;
		this.deviceStrict = deviceStrict;
		this.$nextTick(() => {
			this.webModeFunc();
		});
	},
	beforeMount() {
		window.addEventListener('resize', this.webModeFunc);
	},
	beforeDestroy() {
		window.onlanguagechange = null;
		window.removeEventListener('resize', this.webModeFunc);
		window.removeEventListener('setItem', () => {});
	},
	computed: {
		loadingShow() {
			return this.$store.state.loading;
		},
	},
};
</script>
<style scoped lang='scss'>
	body {
		-webkit-text-size-adjust: 100% !important;
		touch-action: manipulation;
	}
	.index,
	.content {
		position: relative;
		z-index: 1;
		width: 100%;
		// height: 100vh;
		// overflow-y: auto;
		-webkit-overflow-scrolling:touch
	}
	.loading {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.van-overlay {
		z-index: 100;
	}
	/deep/.van-hairline--bottom::after {
		border-bottom-width: 0;
	}

	/deep/.van-cell {
		margin-bottom: 20px;
		background-color: #F5F6F7 !important;
		border-radius: 8px !important;

		.van-field__control {
			font-size: 14px !important;
		}
	}

	.hover-dom {
		cursor: pointer;
		user-select: none;
		-ms-user-select: none;
		-webkit-user-select: none;
	}

	.hover-dom:hover {
		opacity: .9;
	}
</style>
<style lang='scss'>
body {
	background: #fff;

	margin-right: calc(-1 * (100vw - 100%));
	overflow-x: hidden;

	font-feature-settings: "tnum";

	.el-input__inner, .el-input__inner:hover {
		border-color: #389566 !important;
	}

	.red-txt {
		color: #B53934;
	}
	.red-txt-bold {
		color: #B53934;
		font-weight: bold;
	}
}
.app-pc {
	font-size: 37.5Px !important;
	body {
		position: relative;
	}

	#login-frame {
		width: 450px;
		height: 450px;
	}

	.toast-popup {
		.popup-content-area {
			padding-bottom: 50px;
			text-align: center;
		}
	}
}
.app-mobile {
	body {
		max-width: 100vw;
	}
	.login-popup {
		.popup-content-box {
			max-width: 90vw !important;
		}
		.popup-content-area {
			max-height: calc(90vh - 175px) !important;
			overflow-x: hidden !important;
		}
	}
	#login-frame {
		width: calc(90vw - 36px);
		min-height: 400PX;
	}
	.toast-popup {
		.popup-content-area {
			padding-bottom: 30px;
			text-align: center;
		}
	}
}

::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}
::-webkit-scrollbar-thumb {
	border-radius: 5px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: #8E8E8E;
}
::-webkit-scrollbar-track {
	// box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	// border-radius: 5px;
	// background: #ededed;
}

.orientation-tips {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	z-index: 9999;

	background-color: #000000;

	color: #FFFFFF;
	font-size: 16px;

	img {
		margin-bottom: 36px;
		width: 50px;
	}
}

@media only screen and (max-width: 700px) {
	.app-pc {
		font-size: 25.5Px !important;
	}
}

.normal-btn {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 45px;
	border-radius: 8px;
	background-color: #E4004F;

	color: #FFFFFF;
	font-weight: 500;
	font-size: 14px;
}
.normal-btn-disable {
	background-color: #FACCDC !important;
}

.van-toast--html, .van-toast--text {
	width: auto;
}
</style>
